var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 141,
    viewBox: "0 0 90 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 -149.937C8.5 -156.283 13.6664 -161.432 20.0448 -161.432H20.0449L447.695 -161.5C451.627 -161.5 455.364 -159.801 457.939 -156.846L479.59 -131.987C482.039 -129.172 483.391 -125.575 483.394 -121.852L483.5 -10.9301C483.503 -6.75722 482.009 -2.71957 479.286 0.452728L458.411 24.7719C455.836 27.7719 452.069 29.5 448.106 29.5H20.0466C13.6681 29.5 8.5 24.351 8.5 18.0049V-149.937Z",
    stroke: "#CDF1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 -42.937C74.5 -49.2831 79.6664 -54.4321 86.0448 -54.4321H86.0449L513.695 -54.5C517.627 -54.5 521.364 -52.8012 523.939 -49.846L545.59 -24.987C548.039 -22.1723 549.391 -18.5751 549.394 -14.852L549.5 96.0699C549.503 100.243 548.009 104.28 545.286 107.453L524.411 131.772C521.836 134.772 518.069 136.5 514.106 136.5H86.0466C79.6681 136.5 74.5 131.351 74.5 125.005V-42.937Z",
    stroke: "#CDF1F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1201_18170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 141
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H82C86.4183 0 90 3.58172 90 8V141H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1201_18170)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDetail);
export default __webpack_public_path__ + "static/media/card-detail.4e60678d7334fb128efb901b4eeedfa3.svg";
export { ForwardRef as ReactComponent };